"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPractitioner = void 0;
var isPractitioner = function (user, projectId) {
    try {
        return !user.roles
            .find(function (role) {
            return role.projectId === +projectId;
        })
            .name.toLowerCase()
            .includes('client');
    }
    catch (e) {
        return true;
    }
};
exports.isPractitioner = isPractitioner;
